import { render, staticRenderFns } from "./veStuStipendTypeShow.vue?vue&type=template&id=3f89793f&scoped=true"
import script from "./veStuStipendTypeShow.vue?vue&type=script&lang=js"
export * from "./veStuStipendTypeShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f89793f",
  null
  
)

export default component.exports